import {
  afterNextRender,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { ScrollAnimateDirective } from '../../../directives/scroll-animate.directive';

@Component({
  selector: 'app-discover-section',
  imports: [ScrollAnimateDirective],
  templateUrl: './discover-section.html',
  styleUrl: './discover-section.css',
})
export class DiscoverSection {
  @ViewChild('discoverTitleRef') discoverTitleRef!: ElementRef<HTMLElement>;
  @ViewChild('discoverTitleRef2') discoverTitleRef2!: ElementRef<HTMLElement>;
  @ViewChild('sportTrack') sportTrackRef!: ElementRef<HTMLElement>;

  isMobile = false;

  private readonly NUM_SETS = 10;

  private sportImages = [
    { src: 'flexible_image/badminton_small.png', alt: 'Badminton' },
    { src: 'flexible_image/bassketball_small.png', alt: 'Basketball' },
    { src: 'flexible_image/football_small.png', alt: 'Football' },
    { src: 'flexible_image/picketball_small.png', alt: 'Pickleball' },
    { src: 'flexible_image/valleyball_small.png', alt: 'Volleyball' },
  ];

  // NUM_SETS copies rendered in the DOM; the animation always moves exactly
  // one set's width (measured at runtime), so the loop is truly seamless
  // regardless of screen size or image dimensions.
  readonly trackImages = Array.from({ length: this.NUM_SETS }, () => this.sportImages).flat();

  constructor() {
    afterNextRender(() => {
      this.isMobile = window.innerWidth < 768;

      const track = this.sportTrackRef?.nativeElement;
      if (track) {
        // totalScrollWidth / NUM_SETS = exact pixel width of one repeating set
        const oneSetPx = track.scrollWidth / this.NUM_SETS;
        track.style.setProperty('--scroll-distance', `-${oneSetPx}px`);
      }
    });
  }

  scrollTitleIntoView() {
    if (this.discoverTitleRef?.nativeElement || this.discoverTitleRef2?.nativeElement) {
      // if (this.isMobile) {
      //   this.discoverTitleRef2.nativeElement.scrollIntoView({
      //     behavior: 'smooth',
      //     block: 'start',
      //     inline: 'nearest',
      //   });
      // } else {
      this.discoverTitleRef.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
    // }
  }
}
